/**
 * @desc 查询帮助文档目录树
 */
import { HelpLinkEntity } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryHelpLinkTreeParameter = never

const method = 'GET'
const url = '/content/mall/help/link/tree'

export const queryHelpLinkTreeApi = (
  params?: QueryHelpLinkTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<HelpLinkEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryHelpLinkTreeApi.method = method
queryHelpLinkTreeApi.url = url
